import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: false,
    resourceName: 'refuel',
    routerUrl: '/refuel',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Refuel')),
    children: [
      //$MORE$
    ],
  },
];
